import axios from '../../../Utils/axios';
import unAuthAxios from '../../../Utils/unAuthAxios';
import { v1 as uuidv1 } from 'uuid';

const globals = require('../../../config/' +
  process.env.REACT_APP_STAGE +
  '/Portal/globals');

// GET param 변환
export function getURL(API, param) {
  let url = API;
  if (param !== undefined && param !== '') {
    for (let val in param) {
      if (
        !(
          param[val] === undefined ||
          param[val] === null ||
          String(param[val]) === ''
        )
      ) {
        if (url.indexOf('?') > -1) url += '&';
        else url += '?';
        url += val + '=' + param[val];
      }
    }
  }
  return url;
}

// 오브젝트 스토리지 download url 획득
const getObjectStorageDownloadUrl = (param) => {
  const url = getURL(
    `${globals.exApiUrl}/objectStorage/downloadUrl/${param.filename}`
  );

  return unAuthAxios.get(url).then((response) => {
    return response;
  });
};

// 오브젝트 스토리지 Delete
const setObjectStorageDelete = (param) => {
  const url = getURL(`${globals.exApiUrl}/objectStorage/${param.filename}`);

  return axios.delete(url).then((response) => {
    return response;
  });
};

// 오브젝트 스토리지 파일 업로드(파일업로드)
const setObjectStorageUpload = (param) => {
  let lastDot = param.file.name.lastIndexOf('.');
  let fileExt = param.file.name
    .substring(lastDot, param.file.name.length)
    .toLowerCase();
  const fileName = uuidv1() + fileExt;

  // >> PresignedUrl 획득 후 업로드
  // const url = getURL(
  //   `${globals.exApiUrl}/objectStorage/upload/${fileName}`
  // );

  // return new Promise((resolve, reject) => {
  //   axios.get(url).then((response) => {
  //     // return response;
  //     if (response.status === 200) {
  //       let formData = new FormData();

  //       formData.append('file', param.file);
  //       formData.append('type', param.file.type);

  //       axios.put(response.data, formData).then((res) => {
  //         resolve({ ...res, fileName: fileName, file: param.file });
  //       });
  //     }
  //   });
  // });

  //>> API에서 바로 ObjectStorage로 업로드 진행
  const url = getURL(
    `${globals.exApiUrl}/objectStorage/uploadFile/${param.bucket}/${fileName}`
  );

  let formData = new FormData();

  formData.append('file', param.file);
  // formData.append('type', param.file.type);

  return new Promise((resolve, reject) => {
    axios.post(url, formData).then((response) => {
      resolve({ ...response, fileName: fileName, file: param.file });
    });
  });
};

const getObjectStorageAlwaysDownloadUrl = (param) => {
  const url = getURL(
    `${globals.commonApiUrl}/api/storage/alwaysDownloadUrl/${param.bucket}/${param.fileName}`
  );

  return unAuthAxios.get(url).then((response) => {
    return response;
  });
};

// 오브젝트 스토리지 템플릿 download
const getTemplateDownload = (param) => {
  const url = getURL(
    `${globals.exApiUrl}/objectStorage/management/attach/${param.attachmentName}`,
    { bucket: param.bucket }
  );
  return axios.get(url).then((response) => {
    return response;
  });
};

const sendMail = (param) => {
  const url = `${globals.exApiUrl}/mail`;

  return unAuthAxios.post(url).then((response) => {
    return response;
  });
};

const getCode = (param) => {
  const url = getURL(`${globals.exApiUrl}/code`, param);

  return unAuthAxios.get(url).then((response) => {
    return response;
  });
};

export default {
  getObjectStorageDownloadUrl,
  setObjectStorageDelete,
  setObjectStorageUpload,
  getObjectStorageAlwaysDownloadUrl,
  getTemplateDownload,

  sendMail,

  getCode,
};
